import LandingDetail from '../components/LandingPage/LandingDetail';
export default function LandingPage() {
  return <LandingDetail />;
}
